import React from 'react';
import { SummaryRow } from '../../../Summary/SummaryRow';
import { VQ } from '../../../../store/student/types';
import { IVisaPrepForm, IOtherTravellers } from '../../../../types';
import { boolToYesNo } from '../../../../utilities/formatting';
import { relationshipLabel } from '../../../pages/visa/other-travellers/qPage1/utils';
import { parseDate, formatDate } from 'shared-components';
import { SummaryGroup } from '../../../Summary/SummaryGroup';
import { Box } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

function VisaPrepOtherTravellersInfo(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  const renderOtherTravellers = () => {
    const allOtherTravellers: React.ReactNode[] = [];
    if (props.otherTravellers && props.otherTravellers.length) {
      props.otherTravellers.forEach((traveller: IOtherTravellers, i: number) => {
        allOtherTravellers.push(
          <SummaryGroup title={t('forms.visa:traveller', { i: i + 1 })} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={VQ.RELATIONSHIP_TO_YOU}
              label={t('forms.visa:whatIsThisPersonSRelationshipToY')}
              value={traveller.relationship ? relationshipLabel(traveller.relationship) : undefined}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.RELATIONSHIP_TO_YOU_OTHER}`}
              value={traveller.relationshipOther}
              label={t('forms.visa:otherRelationship')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.ADULT_OR_CHILD}
              label={t('forms.visa:areTheyAnAdultOrChild')}
              value={String(traveller.adultOrChild).toLowerCase()}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.NATIONALITY}-${i}`}
              value={traveller.nationality}
              label={t('forms.visa:nationality')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.SAME_NATIONALITY}
              label={t('forms.visa:haveTheyAlwaysHadTheSameNational')}
              value={boolToYesNo(traveller.sameNationality)}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.FAMILY_NAME}`}
              value={traveller.familyName}
              label={t('forms.visa:familyName')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.GIVEN_NAME}`}
              value={traveller.givenName}
              label={t('forms.visa:givenName')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.DOB}
              label={t('forms.visa:dateOfBirth')}
              value={traveller.dob ? formatDate(parseDate(traveller.dob), 'DD/MM/YYYY') : ''}
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.HAS_UK_VISA}
              label={t('forms.visa:doTheyHaveAVisaForTheUk')}
              value={boolToYesNo(traveller.ukVisa)}
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.HAS_PASSPORT}
              label={t('forms.visa:doTheyHaveAPassportOrTravelDocum')}
              value={boolToYesNo(traveller.hasPassport)}
            />
            {traveller.hasPassport ? (
              <SummaryRow
                className={'visa-summary'}
                key={VQ.PASSPORT_NUMBER}
                value={traveller.passportNumber}
                label={t('forms.visa:currentPassportOrTravelDocumentN')}
              />
            ) : null}
          </SummaryGroup>,
        );
      });
    }
    return allOtherTravellers;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.TRAVELLING_WITH_OTHERS}
        label={t('forms.visa:travellingWithOthers')}
        fullLabel={`Will you be travelling to the UK with anyone you have not mentioned in the previous sections?`}
        value={boolToYesNo(props.travellingWithOthers)}
      />
      {props.travellingWithOthers ? (
        <>
          <SummaryRow className={'visa-summary'} label={t('forms.visa:howMany2')} value={props.otherTravellers?.length} />
          <Box as="ol" pl={8} key={'Other travellers'}>
            {renderOtherTravellers()}
          </Box>
        </>
      ) : null}
    </>
  );
}

export default VisaPrepOtherTravellersInfo;
